<script>
  import Layout from "../../layouts/auth";
  import appConfig from "@/app.config";
  import {VueTelInput} from 'vue-tel-input'

  export default {
    components: { Layout, VueTelInput },
    page: {
      title: "Home",
      meta: [{ name: "description", content: appConfig.description }]
    },

    data() {
      return {
        mobile_number: null
      };
    },

    methods: {
      handleSubmit() {
        let mobile_number = this.mobile_number;

        this.callAPI({
          endpoint: `/member/login`,
          type: 'POST',
          data: {mobile_number},
          sweetalert:true,
          successCallback: (response) => {
            this.$router.push({ name: 'Member Otp', params: {mobile: response.data.mobile_number}});
          },
          failureCallBack: (error) => {
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message
            });
          }
        });
      }
    }
  }
</script>
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h4 class="text-primary calibri">पारसधाम ऑनलाइन</h4>
                  <p>Members update</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>

            <p class="text-primary">Please enter your registered mobile number to continue.</p>

            <b-form class="p-2" @submit.prevent="handleSubmit">

              <div class="form-group">
                <label class="required">Mobile Number</label>
                <vue-tel-input v-model="mobile_number" :validCharactersOnly="true" :required="true"></vue-tel-input>
              </div>

              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block">Continue</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>